import { render, staticRenderFns } from "./liveMeeting.vue?vue&type=template&id=4980f8ba&"
import script from "./liveMeeting.vue?vue&type=script&lang=js&"
export * from "./liveMeeting.vue?vue&type=script&lang=js&"
import style0 from "./liveMeeting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports